var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.51952 14.9358C12.3835 6.31193 14.8154 2 18.6667 2C22.5178 2 24.9498 6.31193 29.8138 14.9358L30.4198 16.0105C34.4618 23.1768 36.4828 26.76 34.6562 29.38C32.8297 32 28.3107 32 19.2728 32H18.0605C9.0226 32 4.50362 32 2.6771 29.38C0.850567 26.76 2.87152 23.1768 6.91342 16.0105L7.51952 14.9358Z",
    stroke: "#FFA17E",
    strokeWidth: 3.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 10.3333V18.6666",
    stroke: "#FFA17E",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 25.3333C19.5871 25.3333 20.3333 24.5871 20.3333 23.6667C20.3333 22.7462 19.5871 22 18.6667 22C17.7462 22 17 22.7462 17 23.6667C17 24.5871 17.7462 25.3333 18.6667 25.3333Z",
    fill: "#FFA17E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAlerts);
export default __webpack_public_path__ + "static/media/Total Alerts.476451c3912797be1970e150743b2a42.svg";
export { ForwardRef as ReactComponent };